import { Box, Skeleton } from '@mui/material';
import { VideoEditionsEditGridSkeleton } from './VideoEditionsEditGridSkeleton';

/**
 * Full tab skeleton: chip toolbar + create action row (as in {@link VideoEditionsEditList}) and a grid of card placeholders.
 */
export function VideoEditionsEditListSkeleton() {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: 2,
          mb: 2,
        }}
      >
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Skeleton variant="rounded" animation="wave" width={220} height={32} />
          <Skeleton variant="rounded" animation="wave" width={180} height={32} />
        </Box>
        <Box sx={{ ml: 2 }}>
          <Skeleton variant="rounded" animation="wave" width={160} height={36} />
        </Box>
      </Box>
      <VideoEditionsEditGridSkeleton />
    </Box>
  );
}
